import { useFocusEffect, useNavigation } from "@react-navigation/core";
import { useCallback } from "react";
import {
    ScreenHeaderFilterItem,
    useScreenHeaderFilters,
} from "../../hooks/use-screen-header-filters";
import ScreenHeader from "./ScreenHeader";
import { getHeaderTitle } from "@react-navigation/elements";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { StackScreenProps } from "@react-navigation/stack";

type ScreenParams = StackScreenProps<RootStackParamList>;

type ScreenHeaderFiltersProps<T> = {
    activeFilters: ScreenHeaderFilterItem<T>[];
    defaultActiveFiltersValues: T[];
    uniqueSelection?: boolean;
};

export const ScreenHeaderFilters = <T extends string>({
    activeFilters,
    defaultActiveFiltersValues,
    uniqueSelection = false,
}: ScreenHeaderFiltersProps<T>) => {
    const navigation = useNavigation<ScreenParams["navigation"]>();

    const { screenFilterDropdownProps, hasCustomFilters } = useScreenHeaderFilters<T>({
        items: activeFilters,
        uniqueSelection,
        defaultActiveFiltersValues,
    });

    useFocusEffect(
        useCallback(() => {
            navigation.setOptions({
                header: ({ route, options }) => {
                    const title = getHeaderTitle(options, route.name);

                    return (
                        <ScreenHeader
                            actions={[{ icon: "filter", label: "", ...screenFilterDropdownProps }]}
                            actionButtonWithBadge={hasCustomFilters}
                            label={title}
                        />
                    );
                },
            });
        }, [hasCustomFilters, navigation, screenFilterDropdownProps]),
    );

    return null;
};
